import React, { useState } from "react";
import * as Styled from "./ManageTemplateComponent.styled";
import { useNavigate } from "react-router-dom";
import { TemplateCard } from "./template-card";
import { ReorderContent } from "./reorder-content";
import { getLayoutImage, LayoutTemplates } from "../../libs";
import { FullScreenPreview } from "./fullscreen-preview";
import { userService } from "../../services";

export const ManageTemplateComponent: React.FC = () => {
  const navigate = useNavigate();
  const [showReorderModal, setShowReorderModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);

  const [liveStreamLayout, setLiveStreamLayout] = useState<LayoutTemplates>(LayoutTemplates.Layout1);

  const fetchLiveStreamLayout = React.useCallback(async () => {
    try {
      var layoutValue = await userService.getUserKVStoreKey("liveStreamLayout");
      if (!isNaN(parseInt(layoutValue?.value))) {
        setLiveStreamLayout(parseInt(layoutValue.value));
      } else {
        setLiveStreamLayout(LayoutTemplates.Layout1);
      }
    } catch (error) {
      console.error("Error fetching live stream layout:", error);
    }
  }, []);

  React.useEffect(() => {
    fetchLiveStreamLayout();
  }, [fetchLiveStreamLayout]);
  return (
    <>
      <Styled.StyledContainer>
        <Styled.Header>
          <Styled.LeftSection>
            Manage Templates
          </Styled.LeftSection>
          <Styled.RightSection>
            <Styled.CustomButton variant="outline-secondary" onClick={() => setShowReorderModal(true)}>Reorder Content</Styled.CustomButton>
            <Styled.CustomButton variant="outline-secondary" onClick={() => setShowPreviewModal(true)}>Fullscreen Preview</Styled.CustomButton>
          </Styled.RightSection>
        </Styled.Header>
        <Styled.Description>
          You can choose templates for your playlists and you can reorder how they are displayed.
        </Styled.Description>
        <TemplateCard
          title="Playlists"
          subtitle="All the playlists can be managed here for display."
          svgSrc={getLayoutImage(LayoutTemplates.Layout1)}
          onClick={() => navigate("/manage-libraries/manage-templates/playlists")}
        />
        <TemplateCard
          title="Video on Demand"
          subtitle="All the videos you have stored in the VOD folder will be displayed here."
          svgSrc={getLayoutImage(LayoutTemplates.Layout2)}
          onClick={() => navigate("/manage-libraries/manage-templates/vod")}
        />
        <TemplateCard
          title="Live Streams"
          subtitle="All the live streams can be managed here for display."
          svgSrc={getLayoutImage(liveStreamLayout)}
          onClick={() => navigate("/manage-libraries/manage-templates/live-streams")}
        />
      </Styled.StyledContainer>
      <ReorderContent show={showReorderModal} onHide={() => setShowReorderModal(false)} onOpenPreview={() => setShowPreviewModal(true)} />
      <FullScreenPreview show={showPreviewModal} onHide={() => setShowPreviewModal(false)} />

    </>
  );
}